import React from "react";
import { connect } from "react-redux";

function LoaderMask({ loaderMask }) {
  return (
    <>
      {loaderMask.show && (
        <div className="opus_loader">
          <div className="lds-spinner">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
          <div className="lds-text">{loaderMask.text}</div>
        </div>
      )}
    </>
  );
}

function mapStateToProps(state) {
  const { loaderMask } = state;
  return {
    loaderMask,
  };
}

const connectedLoaderMask = connect(mapStateToProps)(LoaderMask);
export { connectedLoaderMask as LoaderMask };
